import { render, staticRenderFns } from "./SelectOffersForCopy.vue?vue&type=template&id=bce3eb94"
import script from "./SelectOffersForCopy.vue?vue&type=script&lang=js"
export * from "./SelectOffersForCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports